import { Component, OnInit, ViewChild, TemplateRef } from '@angular/core';

import { BsModalService } from 'ngx-bootstrap/modal';
import { BsModalRef } from 'ngx-bootstrap/modal/bs-modal-ref.service';

import { GlobalMessageService } from '../../services/global-message.service';
import { AdminService } from './../../services/admin.service';
import { CacheService } from '../../global/ng2-cache/services/cache.service';
import { SessionService } from './../../services/session2.service';
import { ConfirmDialogComponent } from '../../global/confirm-dialog/confirm-dialog.component';
import { Constants } from '../../global/constants';

@Component({
  selector: 'app-admin-failed-tasks',
  templateUrl: './admin-failed-tasks.component.html'
})
export class AdminFailedTasksComponent implements OnInit {
  @ViewChild('pauseBatchesDialog') pauseBatchesDialog: TemplateRef<any>;

  pauseBatchesDialogRef: BsModalRef;
  loadingPage: boolean = true;
  taskHistory: any[] = [];
  selectedAccount: any[];
  selectedType: any[];
  selectedRetry: any[];
  selectedPartner: any[];
  accounts: any[] = [];
  types: any[] = [];
  retries: any[] = [{ id: 1, itemName: 1}, {id: 2, itemName: 2}, {id: 3, itemName: 3}, {id: 4, itemName: 4}];
  partners: any[] = [
    { id: 'eloqua', itemName: 'Eloqua' },
    { id: 'marketo', itemName: 'Marketo' },
    { id: 'hubspot', itemName: 'HubSpot' },
    { id: 'pardot', itemName: 'Pardot' },
  ];
  selectAll: boolean = false;
  countSelected: number = 0;
  pauseSkillsToo: boolean = false;

  accountDDSettings: any = {
    text: 'All Accounts',
    enableSearchFilter: true,
    badgeShowLimit: 1,
    singleSelection: true,
    classes: 'font-size-sm'
  };

  typeDDSettings: any = {
    text: 'All Types',
    enableSearchFilter: false,
    badgeShowLimit: 1,
    singleSelection: true,
    classes: 'font-size-sm capitalize'
  };

  retryDDSettings: any = {
    text: 'All Retries',
    enableSearchFilter: false,
    badgeShowLimit: 1,
    singleSelection: true,
    classes: 'font-size-sm capitalize'
  };

  partnerDDSettings: any = {
    text: 'All Partners',
    enableSearchFilter: false,
    badgeShowLimit: 1,
    singleSelection: true,
    classes: 'font-size-sm capitalize'
  };

  constructor(
    private globalMessageService: GlobalMessageService,
    private adminService: AdminService,
    private cacheService: CacheService,
    private sessionService: SessionService,
    private modalService: BsModalService,
    private constants: Constants
  ) { }

  ngOnInit() {
    this.constants.jobTypes.forEach(t => {
      this.types.push({ id: t, itemName: t });
    });

    if (!this.cacheService.get('session')) {
      this.sessionService.getSession(true).subscribe(
        (session: any) => {
          this.initView();
        }
      );
    }
    else {
      this.initView();
    }
  }

  resetFilters() {
    this.selectedAccount = null;
    this.selectedType = null;
    this.selectedRetry = null;
    this.selectedPartner = null;
    this.initView();
  }

  filterByAccount(accountId) {
    let targetAccount = this.accounts.find(a => a.id == accountId);
    this.selectedAccount = [targetAccount];
    this.refresh();
  }

  refresh() {
    this.initView();
  }

  selectAllHistory() {
    this.selectAll = !this.selectAll;
    this.countSelected = 0;
    this.taskHistory.forEach(h => {
      if (!h.pretty.hide) {
        h.pretty.selected = this.selectAll;
        if (h.pretty.selected) {
          this.countSelected++;
        }
      }
    });
  }

  showDetail(item) {
    if (!item.pretty.detail && !item.integration_log && item.batch.requestId && item.batch.requestId.length > 0) {
      this.adminService.getIntegrationLog(item.batch.requestId).subscribe(
        (result: any) => {
          item.integration_log = result || [];
          item.integration_log.sort((a, b) => {
            let ad = new Date(a.created_at);
            let bd = new Date(b.created_at);
            if (ad > bd) {
              return 1;
            }
            else {
              return -1;
            }
          });
          item.pretty.detail = !item.pretty.detail;
        });
    }
    else {
      item.pretty.detail = !item.pretty.detail;
    }
  }

  resetBatch(batch) {
    let me = this;
    this.modalService.show(ConfirmDialogComponent, Object.assign({}, {
      initialState: {
        message: `Please confirm you would like to reset this batch`,
        confirm: function () {
          me.resetOneBatch(batch._id).then(() => {
            me.initView();
            me.globalMessageService.message('Batch was reset');
          });
        }
      }
    }));
  }

  resetBatches() {
    let me = this;
    let selected = [];
    this.taskHistory.forEach(h => {
      if (h.pretty.selected) {
        selected.push(h);
      }
    });

    this.modalService.show(ConfirmDialogComponent, Object.assign({}, {
      initialState: {
        message: `Please confirm you would like to reset the selected batches (${selected.length} selected)`,
        confirm: function () {
          Promise.all(selected.map(h => {
            return me.resetOneBatch(h.batch._id);
          }))
            .then(() => {
              me.initView();
              me.globalMessageService.message(`${selected.length} batch(es) were reset`);
            });
        }
      }
    }));
  }

  pauseBatch(batch) {
    let me = this;
    this.modalService.show(ConfirmDialogComponent, Object.assign({}, {
      initialState: {
        message: `Please confirm you would like to pause this batch`,
        confirm: function () {
          me.pauseOneBatch(batch._id).then(() => {
            me.initView();
            me.globalMessageService.message('Batch was paused');
          });
        }
      }
    }));
  }

  showPauseBatchModal() {
    this.pauseBatchesDialogRef = this.modalService.show(this.pauseBatchesDialog);
  }

  pauseBatches() {
    let me = this;
    let selected = [];
    this.taskHistory.forEach(h => {
      if (h.pretty.selected) {
        selected.push(h);
      }
    });
    Promise.all(selected.map(h => {
      return me.pauseOneBatch(h.batch._id);
    }))
      .then((r) => {
        this.initView();
      });

    if (this.pauseSkillsToo) {
      this.pauseTaks(selected);
    }
    else {
      me.globalMessageService.message(`${selected.length} batch(es) were paused`);
    }
  }

  deleteBatch(batch: any) {
    let me = this;
    this.modalService.show(ConfirmDialogComponent, Object.assign({}, {
      initialState: {
        message: `Please confirm you would like to delete this batch`,
        confirm: function () {
          me.deleteOneBatch(batch._id).then(() => {
            me.initView();
            me.globalMessageService.message('Batch was deleted');
          });
        }
      }
    }));
  }

  deleteBatches() {
    let me = this;
    let selected = [];
    this.taskHistory.forEach(h => {
      if (h.pretty.selected) {
        selected.push(h);
      }
    });

    this.modalService.show(ConfirmDialogComponent, Object.assign({}, {
      initialState: {
        message: `Please confirm you would like to delete the selected batches (${selected.length} selected)`,
        confirm: function () {
          Promise.all(selected.map(h => {
            return me.deleteOneBatch(h.batch._id);
          }))
            .then(() => {
              me.initView();
              me.globalMessageService.message(`${selected.length} batch(es) were deleted`);
            });
        }
      }
    }));
  }

  splitBatch(batch) {
    let me = this;
    this.modalService.show(ConfirmDialogComponent, Object.assign({}, {
      initialState: {
        message: `Please confirm you would like to split this batch into ${batch.item_ids.length} single-email batches`,
        confirm: () => {
          me.adminService.splitTaskBatch(batch._id).subscribe(
            () => {
              me.initView();
              me.globalMessageService.message('Batch was split');
            },
            () => {
              me.globalMessageService.error(`Failed to split batch`);
            }
          );
        }
      }
    }));
  }

  clickCheckBox(value: boolean = null) {
    if(value) {
      this.pauseSkillsToo = value;
    }
    else {
      this.pauseSkillsToo = !this.pauseSkillsToo;
    }
  }

  pauseTaks(selected: any) {
    let me = this;
    let fSkillSet: any = [];
    selected.forEach((task) => {
      // ! structure following automate job model
      // ! Minimal structure -> { jobId: string, updatedTasks: [ { taskId: string, paused: bool, paused_reason: string } ] };

      // find if we alreday have the automate_job_id
      let fJob: any = null;
      fSkillSet.some((pause) => {
        if (pause.jid == task.batch.automate_job_id) {
          fJob = pause;
          // returning true breaks the "some" loop
          return true;
        }
      });

      let jt: any = {};
      if (fJob) {
        // find if we already have the task in the inner-array
        let fTask: boolean = false;
        fJob.updatedTasks.some((taskId) => {
          if (taskId = task.batch.taskId) {
            fTask = true;
            return true;
          }
        });
        if (!fTask) {
          let temp: any = {};
          temp.paused = true;
          temp.paused_reason = 'Manual';
          temp.taskId = task.batch.taskId;
          fJob.updatedTasks.push(temp);
        }
      }
      else {
        jt.jid = task.batch.automate_job_id;
        let temp: any = {};
        temp.paused = true;
        temp.paused_reason = 'Manual';
        temp.taskId = task.batch.taskId;
        jt.updatedTasks = [temp];
        fSkillSet.push(jt);
      }
    });

    if (fSkillSet.length > 0) {
      me.adminService.updateTasks(fSkillSet).subscribe(
        () => {
          me.initView();
          me.globalMessageService.message(`${selected.length} batch(es) were paused and ${fSkillSet.length} task(s) paused`);
        },
        () => {
          // TODO: show or log error?
        }
      );
    }
  }

  selectHistoryItem(item: any) {
    item.pretty.selected = !item.pretty.selected;
    if (item.pretty.selected) {
      this.countSelected++;
    }
    else {
      this.countSelected--;
    }
  }

  private initView() {
    const accountFilter = (this.selectedAccount && this.selectedAccount.length) > 0 ? this.selectedAccount[0].id : null;
    const typeFilter = (this.selectedType && this.selectedType.length > 0) ? this.selectedType[0].id : null;
    const retryFilter = (this.selectedRetry && this.selectedRetry.length > 0) ? this.selectedRetry[0].id : null;
    const partnerFilter = (this.selectedPartner && this.selectedPartner.length > 0) ? this.selectedPartner[0].id : null;
    this.selectAll = false;
    this.pauseSkillsToo = false;
    this.countSelected = 0;
    this.loadingPage = true;

    if (this.accounts.length == 0) {
      this.adminService.getActiveAccounts().subscribe((result: any) => {
        result.forEach((a) => {
          this.accounts.push({ id: a._id, itemName: a.name });
        });
      });
    }

    this.adminService.getAllFailedTasks(accountFilter, typeFilter, null, retryFilter, partnerFilter).subscribe(
      (result: any) => {
        let temp = result;
        this.taskHistory = [];
        temp.forEach((h) => {
          let t = {
            batch: h,
            pretty: {
              hide: false,
              detail: false,
              dba: {
                batchQ: `db.batch_q.find({_id: ObjectId('${h._id}')}).pretty()`,
                integrationLog: `db.integration_log.find({requestId: '${h.requestId}'}).pretty()`
              },
              raw: false,
              integration_log: false,
              selected: false
            }
          };
          this.taskHistory.push(t);
        });
        this.loadingPage = false;
      },
      (error) => {
        console.log(error);
      }
    );
  }

  private resetOneBatch(batchId: string): Promise<any> {
    return new Promise((resolve, reject) => {
      this.adminService.resetTaskBatch(batchId).subscribe(
        (result: any) => {
          resolve();
        },
        error => {
          reject();
        }
      )
    });
  }

  private pauseOneBatch(batchId: string): Promise<any> {
    return new Promise((resolve, reject) => {
      this.adminService.pauseTaskBatch(batchId).subscribe(
        (result: any) => {
          resolve();
        },
        error => {
          reject();
        }
      )
    });
  }

  private deleteOneBatch(batchId: string): Promise<any> {
    return new Promise((resolve, reject) => {
      this.adminService.deleteTaskBatch(batchId).subscribe(
        (result: any) => {
          resolve();
        },
        error => {
          reject();
        }
      )
    });
  }
}



// WEBPACK FOOTER //
// ./client/app/admin/admin-failed-tasks/admin-failed-tasks.component.ts